import getAffiliationsInfoService from "../Infrastructure/Reports.service";

export default async function getAffiliationsInfoLogic(zone, betweenDates){
  return getAffiliationsInfoService(zone, betweenDates);
}